import { AuthService } from './auth.service';
//import { AngularFireAuth } from 'angularfire2/auth';
import { Upload } from './upload';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class MediaService {

  medias: FirebaseListObservable<any[]>;
  //media: FirebaseObjectObservable<any>;
  comments : FirebaseListObservable<any[]>;
  userRoles: Array<string>;

  nbComments : number;
  constructor(public af:AngularFireDatabase,  public auth: AuthService ) {

          auth.user.map(user=>{
            return this.userRoles = _.keys(_.get(user,'roles'))
          })
          .subscribe()

        this.medias = this.af.list('/uploads') as FirebaseListObservable<Upload[]>;
        //this.comments = this.af.list('/uploads_comments/'+id) as FirebaseListObservable<any[]>;
      }

      getMedia(id:string,folderid:string, companyId){
        // /${company}/folder/${folder.folderUid}/files/`)
        return this.af.object('/uploads/'+ companyId+'/'+folderid+'/files/'+id) as FirebaseObjectObservable<Upload>;
        //return this.media;
      }

      updateRawMedia(id:string,folderid:string, companyId, value:any){
        return this.af.list('/uploads/'+ companyId+'/'+ folderid + '/files/').update(id, value);
     }

      getComments(id:string){
        return this.af.list('/uploads_comments/'+id) as FirebaseListObservable<any[]>;
      }

      likePicture(id,uid){
        return this.af.list('/picture_likes/'+id).update(uid, { like : true });
      }

      newComment( id:string, message:any){
        return  this.af.list('/uploads_comments/'+id).push(message); //as FirebaseListObservable<any[]>;
      }

      deleteComment(iUid: string, cUid: string){
        return this.af.list('/uploads_comments/' + iUid ).remove(cUid);
      }

      updateMedia(id:string, commentCount:number){
        return this.medias.update(id, {commentsCount : commentCount});
      }


}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/media.service.ts